module.exports = __webpack_public_path__ + "static/img/雷阵雨.1f894fbd.svg";